"use client";

import { useContext } from "react";
import { IRootStore } from "@workspace/types";
import { StoreContext } from "../store/store.context";

export const useStore = <T extends IRootStore = IRootStore>() => {
  const store = useContext(StoreContext);

  if (!store) {
    throw new Error("useStore must be used with StoreProvider");
  }
  return store as T;
};

export const useStoreSelector = <T, K extends IRootStore = IRootStore>(
  selector: (store: K) => T,
): T => {
  const store = useStore<K>();
  return selector(store);
};
